import React from "react";

// Externals
import cn from "classnames";

// DevExtreme componenents
import Button from 'devextreme-react/button';

export function SlideViewNavigation(props) {
  const { classes, viewports, visible, height, selectedIndex, onSelectedIndexChanged } = props;

  const navigationContainerStyle = {
    height: height,
    visibility: visible ? "visible" : "hidden"
  };

  const onBreadcrumpLinkClicked = (event, index) => {
    event.preventDefault();
    onSelectedIndexChanged(index);
  };

  const jump = (value) => {
    onSelectedIndexChanged(prev => prev + value);
  };

  const breadcrump = () => {
    return viewports.map((vp, index) => (
      <span key={index}>
        {index === 0 ? "" : <span>/&nbsp;</span>}
        <a href='/' onClick={(e) => onBreadcrumpLinkClicked(e, index)}>
          {vp.displayName}
        </a>
        <span>&nbsp;</span>
      </span>)
    );
  };

  return (
    <div className={cn(classes.navigationContainer, "dx-theme-background-color", "dx-theme-border-color")} style={navigationContainerStyle}>
      <Button
        stylingMode="text"
        icon="arrowleft"
        disabled={selectedIndex === 0}
        onClick={() => jump(-1)}
      />
      {breadcrump()}
      <Button
        stylingMode="text"
        icon="arrowright"
        disabled={selectedIndex === viewports.length - 1}
        onClick={() => jump(+1)}
      />
    </div>
  )
}